import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import { Box } from '@radix-ui/themes';

import Text from '../../../../shared/Text';

import { Wrapper } from '../../../../shared/ModalComponents';

import { BaseInput, Label } from '../../../../shared/FormStyles';
import ColorPicker from '../../../../shared/ColorPicker';

const CustomColorInput = ({ primaryColor, setFieldValue }) => {
  const { t } = useTranslation('boardSetup');

  return (
    <Wrapper>
      <TitleAccessibityRow>
        <Label htmlFor="logo">{t('customColor.boardColor')}</Label>
        <Accessibility
          variant="small2"
          color="primary.100"
          as="a"
          href="http://learning.airbo.com/en/articles/6041085-setting-up-a-custom-color"
          target="_blank"
        >
          {t('customColor.guidelines')}
        </Accessibility>
      </TitleAccessibityRow>
      <InputWrapper>
        <CustomInput
          id="primary_color"
          name="demo_primary_color"
          type="text"
          onChange={e => setFieldValue('primaryColor', e.target.value)}
          value={primaryColor}
          placeholder="#000000"
        />
        <Box p="0 8px">
          <ColorPicker
            colorChangeHandler={color => setFieldValue('primaryColor', color)}
            initialColor={primaryColor}
            key={primaryColor}
          />
        </Box>
      </InputWrapper>
    </Wrapper>
  );
};

export default CustomColorInput;

const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${themeGet('colors.black.20')};
  border-radius: 8px;
  width: 100%;
  margin-bottom: 16px;
`;

const CustomInput = styled(BaseInput)`
  padding: 10px 16px !important;
  border: 0 !important;
`;

const Accessibility = styled(Text)`
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: ${themeGet('colors.primary.80')};
  }
`;

const TitleAccessibityRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
`;
